<!-- eslint-disable -->
<template>
  <v-card height="100%">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn small color="success" class="mt-5" @click="nuevo" v-if="userCan('fr-providers-create')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn small color="info" class="mt-5 ml-3" @click="getAll">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="4" offset-xl="4">
          <v-container>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Busqueda"
              single-line
              hide-details
            />
          </v-container>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        class="elevation-1"
        mobile-breakpoint="0"
        :search.sync="search"
        :item-class="row_classes"
      >
        <template v-slot:[`item.telefono`]="{ item }">
          {{ item.telefono | telefono }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <template v-if="item.deleted_at">
            <v-btn icon color="success" @click="enableProveedor(item)" v-if="userCan('fr-providers-delete')">
              <v-icon>mdi-delete-restore</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon color="success" @click="editar(item.id)" v-if="userCan('fr-providers-edit')">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="primary" @click="historial(item.id)" v-if="userCan('fr-providers-history')">
              <v-icon>mdi-history</v-icon>
            </v-btn>
            <v-btn icon color="red" @click="disableProveedor(item)" v-if="userCan('fr-providers-delete')">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  export default {
    name: "Index",
    data: () => ({
      search: undefined,
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Contacto", value: "contacto" },
        { text: "Teléfono", value: "telefono" },
        { text: "Correo", value: "email" },
        { text: "Acciones", value: "actions", align: "end" },
      ],
    }),
    computed: {
      ...mapState({
        items: (state) => state.Proveedores.collection,
      }),
    },
    mounted() {
      if (!this.items) this.getAll();
    },
    methods: {
      ...mapActions("Proveedores", [
        "getAll",
        "nuevo",
        "editar",
        "historial",
        "deshabilitar",
        "habilitar",
      ]),
      disableProveedor(item) {
        let pregunta = `¿Deseas deshabilitar al proveedor ${item.nombre}?`,
          text =
            "Los datos no se borran, pero no se podran hacer nuevas compras ni pagos";
        window
          .swal({
            title: pregunta,
            text: text,
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"],
            dangerMode: true,
          })
          .then((confirmado) => {
            if (confirmado) {
              this.deshabilitar(item.id);
            }
          });
      },
      enableProveedor(item) {
        let pregunta = `¿Deseas habilitar al proveedor ${item.nombre}?`;
        window
          .swal({
            title: pregunta,
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"],
            dangerMode: true,
          })
          .then((confirmado) => {
            if (confirmado) {
              this.habilitar(item.id);
            }
          });
      },
    },
  };
</script>
